import { render } from "./MessageItem.vue?vue&type=template&id=0732deb0&scoped=true"
import script from "./MessageItem.vue?vue&type=script&lang=js"
export * from "./MessageItem.vue?vue&type=script&lang=js"

import "./MessageItem.vue?vue&type=style&index=0&id=0732deb0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0732deb0"]])

export default __exports__